import { makeVar } from '@apollo/client'

import { OrderReviewDrawers, OrderReviewErrorFields } from './review.types'

export const orderReviewDrawerVar = makeVar<OrderReviewDrawers | null>(null)

export const orderReviewPartialErrorVar = makeVar<OrderReviewErrorFields>({
  priceType: false,
})

export const refreshOrderDetailsWidget = makeVar<null | (() => void)>(null)
